import "./ProIcon.scss";

export default function ProIcon() {
  return (
    <img
      loading="lazy"
      className={"pro-icn"}
      src={
        "https://www.musthavemenus.com/imageservice/images/img/13/pay-modal/Pro2.svg"
      }
      alt={"Pro"}
    />
  );
}
